export const themes = [
  'coral',
  'coralLight',
  'facebook',
  'landing',
  'runkeeper',
  'waybetter',
  'waybetterLight',
];

export const customThemes = (custom) => themes.concat(custom);
